var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
// ==================== API Methods ====================
export const reportsApi = {
    getReportNodesDropdown: (query) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const response = yield siteX.post("Reports/nodes-dropdown", {
            nodeStatus: (_a = query.nodeStatus) !== null && _a !== void 0 ? _a : "All",
            search: (_b = query.search) !== null && _b !== void 0 ? _b : "",
            pageNumber: (_c = query.pageNumber) !== null && _c !== void 0 ? _c : 1,
            pageSize: (_d = query.pageSize) !== null && _d !== void 0 ? _d : 7,
        });
        return response.data;
    }),
    /**
     * Gets temperature report data for multiple Access Points.
     * Unlike Insights, Reports use user-controlled grouping (not auto-calculated).
     * Each node's data is returned separately (DTO still uses accessPoints).
     *
     * @param query The query parameters for fetching temperature report
     */
    getTemperatureReport: (query) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.post("Reports/temperature", query);
        return response.data;
    }),
    /**
     * Downloads the temperature report as an Excel file.
     * Each selected AP gets its own section in the Excel file.
     *
     * @param query The query parameters (same as getTemperatureReport)
     */
    exportTemperatureReport: (query) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.post("Reports/temperature/export", query, {
            responseType: "blob",
        });
        return response.data;
    }),
    /**
     * Downloads the temperature report as a PDF file.
     * Each selected AP gets its own section in the PDF file.
     *
     * @param query The query parameters (same as getTemperatureReport)
     */
    exportTemperatureReportPdf: (query) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield siteX.post("Reports/temperature/export/pdf", query, {
            responseType: "blob",
        });
        return response.data;
    }),
};
